module.exports = __webpack_public_path__ + "static/media/Group.d419bc3b.svg";